import { Language, type IUser } from '../../User/IUser'
import { ReactComponent as FlagSv } from '../../Icons/flag_sv.svg'
import { ReactComponent as FlagEn } from '../../Icons/flag_gb.svg'
import { ReactComponent as FlagDa } from '../../Icons/flag_da.svg'
import { ReactComponent as FlagDe } from '../../Icons/flag_de.svg'
import { ReactComponent as FlagFr } from '../../Icons/flag_fr.svg'
import { ReactComponent as FlagNl } from '../../Icons/flag_nl.svg'
import { setCookie, getCookie } from '../../Infrastructure/Helpers/cookieHelper'
import {
  COOKIE_NAME,
  COOKIE_CATEGORIES,
} from '../../Infrastructure/Helpers/cookie_constants'

const handleChangeLanguage = (language: Language) => {
  setCookie(COOKIE_NAME.LANGUAGE, language, COOKIE_CATEGORIES.Functional, 365)
  return language
}

const isLanguageSelected = (user: IUser, language: Language) => {
  const userLanguage = getCurrentLanguage(user)
  return userLanguage === language
}

export const getLanguageDropdownItems = (user: IUser) => [
  {
    name: 'Svenska',
    onClick: () => handleChangeLanguage(Language.sv),
    icon: <FlagSv />,
    isSelected: isLanguageSelected(user, Language.sv),
  },
  {
    name: 'English',
    onClick: () => handleChangeLanguage(Language.en),
    icon: <FlagEn />,
    isSelected: isLanguageSelected(user, Language.en),
  },
  {
    name: 'Deutsch',
    onClick: () => handleChangeLanguage(Language.de),
    icon: <FlagDe />,
    isSelected: isLanguageSelected(user, Language.de),
  },
  {
    name: 'Dansk',
    onClick: () => handleChangeLanguage(Language.da),
    icon: <FlagDa />,
    isSelected: isLanguageSelected(user, Language.da),
  },
  {
    name: 'Français',
    onClick: () => handleChangeLanguage(Language.fr),
    icon: <FlagFr />,
    isSelected: isLanguageSelected(user, Language.fr),
  },
  {
    name: 'Nederlands',
    onClick: () => handleChangeLanguage(Language.nl),
    icon: <FlagNl />,
    isSelected: isLanguageSelected(user, Language.nl),
  },
]

export const getLanguageIcon = (language: Language): React.ReactNode => {
  switch (language) {
    case Language.sv:
      return <FlagSv />
    case Language.en:
      return <FlagEn />
    case Language.de:
      return <FlagDe />
    case Language.da:
      return <FlagDa />
    case Language.fr:
      return <FlagFr />
    case Language.nl:
      return <FlagNl />
    default:
      return <FlagSv />
  }
}

export const getCurrentLanguage = (user?: IUser): Language => {
  const cookieLanguage = getCookie(COOKIE_NAME.LANGUAGE) as Language | undefined
  return cookieLanguage || user?.language || Language.sv
}

export const getLanguageFullName = (language: Language): string => {
  switch (language) {
    case Language.sv:
      return 'Svenska'
    case Language.en:
      return 'English'
    case Language.de:
      return 'Deutsch'
    case Language.da:
      return 'Dansk'
    case Language.fr:
      return 'Français'
    case Language.nl:
      return 'Nederlands'
    default:
      return language
  }
}
